import React from "react";
import "./SectionTitle.css";

function SectionTitle({ eyebrow, title, description, center }) {
  return (
    <div className={center ? "section-title section-title--center" : "section-title"}>
      {eyebrow && <span>{eyebrow}</span>}
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </div>
  );
}

export default SectionTitle;